import styled from 'styled-components';
import { nullCoalesc } from '../../../../utils/objects';

interface ITitledValueContainer {
	descSize?: number;
	size?: number;
	display?: string;
	marginTop?: number;
	marginBottom?: number;
	valueSize?: number;
	layout?: string;
	spacing?: number;
	textColor?: string;
}

export const TitledValueContainer = styled.span<ITitledValueContainer>`
	color: #8cabc4;
	line-height: 30px;
	font-size: ${({ descSize, size }) => descSize || size || 14}px;
	display: ${({ display }) => display || 'inline-block'};
	margin-top: ${({ marginTop }) => nullCoalesc(marginTop, 0)}px;
	margin-bottom: ${({ marginBottom }) => nullCoalesc(marginBottom, 0)}px;
	.desc-value {
		font-weight: 700;
		font-size: ${({ valueSize, size }) => valueSize || size || 14}px;
		display: ${({ layout }) => (layout === 'vertical' ? 'inline-block' : 'inline')};
		margin-top: ${({ spacing, layout }) => (layout === 'vertical' ? spacing : 2)}px;
		margin-left: ${({ spacing, layout }) => (layout !== 'vertical' ? spacing : 0)}px;
		color: ${({ textColor }) => textColor || 'inhirit'};
		text-overflow: ellipsis;
		overflow: hidden;
		width: 100%;
	}
`;
